import React, { useState, useEffect, Fragment } from 'react'
import { columns } from './dataTable'
import { Table } from 'components'
import { enhanceTable } from 'components/Table/tableEnhance'
import { Button } from 'antd'
import { useHistory } from 'react-router-dom'
import swal from 'utils/swal'
import { useAuth } from 'hooks'
import RepresentativeRepository from 'egi/repositories/RepresentativeRepository'
import { IAttorney } from 'egi/app/Attorney/attorneyInterfaces'

function WitnessesList () {
  const history = useHistory()
  const user = useAuth()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<IAttorney[]>()
  const [finalColmun, setFinalColumn] = useState<Object[]>(columns(() => {}))

  const IS_AUDITOR = user.level === 'auditor'

  const handleDelete = (id: string, name: string) => {
    swal.confirmNegate({
      title: 'Atenção',
      text: `Tem certeza que deseja deletar a testemunha ${name}?`,
      icon: 'warning',
      confirm: async () => {
        if (id) {
          try {
            const response = await RepresentativeRepository.delete(id)
            swal.basic({ title: 'Sucesso!', icon: 'success', text: response.data?.message })
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            getWitnesses()
          } catch (err) {
            if (err.date?.message) {
              swal.basic({ title: 'Atenção', text: err.date.message, icon: 'warning' })
              return
            }
            swal.basic({ title: 'Atenção', icon: 'warning', text: err.message })
          }
        }
      }
    })
  }

  async function getWitnesses () {
    setLoading(true)
    try {
      const response = await RepresentativeRepository.witnessList()
      const attorneysArray = response.data.data?.representatives
      const [formatedValues, formatedColums] = enhanceTable(attorneysArray || [], columns(handleDelete))

      setData(formatedValues)
      setFinalColumn(formatedColums)
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  useEffect(() => {
    getWitnesses()
  }, [])

  return (
    <Table
      filters={
        <Fragment>
          {!IS_AUDITOR && (
            <Button
              className="w-100"
              type="primary"
              onClick={() => history.push('/auth/witness/create')}
            >
              Adicionar nova testemunha
            </Button>
          )}
        </Fragment>
      }
      data={data}
      columns={finalColmun}
      loading={loading}
    />
  )
}

export default WitnessesList
